import React from 'react';
import { HashRouter, Route, Switch, Router } from 'react-router-dom';
import RecruitmentList from './views/recruitmentList/recruitmentList';
import RecruitmentDetail from './views/recruitmentDetail/recruitmentDetail';

const BasicRoute = () => (
  <HashRouter history={Router}>
    <Switch>
      <Route exact path="/" component={RecruitmentList} />
      <Route exact path="/recruitmentDetails/:id" component={RecruitmentDetail} />
    </Switch>
  </HashRouter>
);

export default BasicRoute;
